<template lang="pug">
include /../../s-pug/mixin-icon
Layout(include-layout-class="true")
   .TeamCreateContainer._relative
      Loading(v-if="busy" radius)
      ._t-center._mb1-5
         ._fs-4._mb05 Choose a listing duration
         //- ._c-grey-500._fs-075 (These can be changed later)
      ._mb1-5._fs-075
         ._mb075._c-grey-400 Included with your listing: 
         ul._c-grey-500
            mixin li(text)
               li._flex._mb05._lineHeight--1dot4&attributes(attributes)
                  ._mr075.ListIcon: +icon({name: 'icon-check'})
                  div= text
            +li('Listing on RemoteFit.com')
            +li('Listing on RemoteFit.com')
            +li('Profile analytics dashboard')
            +li('Unlimited team-member accounts')
            +li('Unlimited profile edits/tweaks')
            +li('Unlimited support for creating/optimizing profile')
      form(@submit.prevent="handleSubmit")
         ._mb1-5
            .Option._mb05._radius._border._borderColor-grey-200._px1._py1._cursor-pointer._block._flex._flex-justifySpaceBetween._flex-alignItemsCenter(v-for="plan in plans" v-on:click="selectPlan(plan.value)" v-bind:class="{'is-selected': selectedPlan === plan.value}")
               ._fs-3._noWrap {{plan.length}}
               ._t-right
                  ._mb05._fs-2._c-grey-600 {{plan.priceTotal}}
                  ._fs-075._c-grey-500 {{plan.priceMonthly}}/mo
         ._mb1-5._fs-075._c-grey-500._lineHeight--1dot4
            | Note: Plan must be paid in full before listing can go live. Paying monthly is not currently an option.
         div
            AddTeamNextBtn
</template>

<style lang="sass" scoped>
.primary
   fill: $green-200
.secondary
   fill: $green-900
.ListIcon svg
   +wh(19px)
   display: inherit
.Option
   &:hover,
   &:focus
      border-color: $grey-400
   &.is-selected
      background-color: $light-blue-vivid-050
      border-color: $light-blue-vivid-600
.TeamCreateContainer
   max-width: 380px
   width: 100%
   +mx(auto)
   background-color: white
   border-radius: $radius
   +boxShadow--2
   +px($s-1)
   padding-top: $s-1-5
   padding-bottom: $s-1
   +above(375px)
      +px($s-1-5)
      padding-bottom: $s-1-5
</style>

<script>
import AddTeamNextBtn from '~/components/AddTeamNextBtn.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
   components: {
      AddTeamNextBtn,
   },
   metaInfo() {
      return {
         title: `Choose a plan`,
      }
   },
   data() {
      return {
         selectedPlan: '12-months', // 12-month plan selected by default
         busy: false,
         plans: [
            {
               value: '12-months',
               priceTotal: '$3000',
               priceMonthly: '$250',
               length: '12 months',
            },
            {
               value: '6-months',
               priceTotal: '$1650',
               priceMonthly: '$275',
               length: '6 months',
            },
            {
               value: '3-months',
               priceTotal: '$900',
               priceMonthly: '$300',
               length: '3 months',
            },
         ],
         errors: {
            nameTeam: null,
            nameCompany: null,
            general: false,
         },
         credentials: {
            nameTeam: null,
            nameCompany: null,
         },
      }
   },
   methods: {
      selectPlan(planValue) {
         this.selectedPlan = planValue
      },
      handleSubmit() {
         this.busy = true
      },
   },
}
</script>
